<template>
	<div class="sub_contents">
		<div class="cont_center">
			<h1 class="title_page">프로모션</h1>

			<div v-if="bannerData && bannerData.path">
				<a href="#" @click="bannerData.linkUrl && routerToBanner(bannerData.linkUrl)">
					<img :src="makeBrandImageUrl(bannerData.path)" alt="" />
				</a>
			</div>

			<div class="event_area">
				<TabArea :tab="tab" :currentTab="currentTab" @click="changeTab" />

				<!-- 전체 탭 -->
				<div class="tab_contents" v-if="currentTab === 0">
					<ul class="event_list">
						<template :key="item.uuid" v-for="item in eventList">
							<li>
								<a :href="'/HFO_PR_003/' + item.uuid" @click.prevent="routerLinkWithLoginCheck(item.uuid, item.replyYn)">
									<div class="event_thumb">
										<img :src="makeBrandImageUrl(item.path)" alt="" />

										<!-- 종료됐을 경우 display: block; -->
										<p class="event_end"
											:style="{ display: item.ingFlag === 'END' ? 'block' : 'none' }">
											<span>종료 이벤트</span>
										</p>
									</div>

									<div class="event_s_info">
										<p class="event_title">
											{{ item.name }}
										</p>

										<p class="event_date">
											{{ item.startDd }} ~ {{ item.endDd }}
										</p>
									</div>
								</a>
							</li>
						</template>
					</ul>
				</div>

				<!-- 진행중 탭 -->
				<div class="tab_contents" v-if="currentTab === 1">
					<ul class="event_list">
						<template :key="item.uuid" v-for="item in eventList">
							<li v-if="item.ingFlag === 'ING'">
								<a :href="'/HFO_PR_003/' + item.uuid" @click.prevent="routerLinkWithLoginCheck(item.uuid, item.replyYn)">
									<div class="event_thumb">
										<img :src="makeBrandImageUrl(item.path)" alt="" />
									</div>

									<div class="event_s_info">
										<p class="event_title">
											{{ item.name }}
										</p>

										<p class="event_date">
											{{ item.startDd }} ~ {{ item.endDd }}
										</p>
									</div>
								</a>
							</li>
						</template>
					</ul>
				</div>

				<!-- 종료 탭 -->
				<div class="tab_contents" v-if="currentTab === 2">
					<ul class="event_list">
						<template :key="item.uuid" v-for="item in eventList">
							<li v-if="item.ingFlag === 'END'">
								<a :href="'/HFO_PR_003/' + item.uuid" @click.prevent="routerLinkWithLoginCheck(item.uuid, item.replyYn)">
									<div class="event_thumb">
										<img :src="makeBrandImageUrl(item.path)" alt="" />

										<!-- 종료됐을 경우 display: block; -->
										<p class="event_end" style="display: block">
											<span>종료 이벤트</span>
										</p>
									</div>

									<div class="event_s_info">
										<p class="event_title">
											{{ item.name }}
										</p>

										<p class="event_date">
											{{ item.startDd }} ~ {{ item.endDd }}
										</p>
									</div>
								</a>
							</li>
						</template>
					</ul>
				</div>

				<!-- 데이터 없음 표시 -->
				<div v-if="eventList.length === 0 && !eventData.isLoading.value" class="no_data_area">
					<p>이벤트가 없습니다.</p>
				</div>

				<!-- 로딩 표시 -->
				<div v-if="eventData.isLoading.value" class="loading_area">
					<p>데이터를 불러오는 중...</p>
				</div>
			</div>
		</div>

		<!-- AlertPopup 추가 -->
		<AlertPopup v-model="showLoginAlert" title="알림" class="alert_popup">
			<template #layer_content>
				<div class="alert-content">
					<p>{{ loginAlertMessage }}</p>
					<div class="alert-buttons">
						<button class="btn btn-primary" @click="handleLoginAlertConfirm">확인</button>
						<button class="btn btn-secondary" @click="handleLoginAlertCancel">취소</button>
					</div>
				</div>
			</template>
		</AlertPopup>
	</div>
</template>

<script>
// import PagingCom from "@/components/PagingCom";
import TabArea from "@/components/TabArea";
import AlertPopup from '@/components/AlertPopup.vue';
import { ref, watch, onMounted } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { getAxios } from "@/lib/AxiosCall";
import { useRouter } from "vue-router";
import { LOCAL_STORAGE_HVM_USERINFO } from '@/lib/Config';
import { SessionManager } from '@/lib/SessionManager'; // SessionManager import 추가

export default {
	components: {
		// PagingCom,
		TabArea,
		AlertPopup,
	},
	data() {
		return {
			currentTab: 1, // 진행중 탭을 기본값으로 변경 (0: 전체, 1: 진행중, 2: 종료)
			tab: [
				{
					name: "전체",
				},
				{
					name: "진행중",
				},
				{
					name: "종료",
				},
			],
			// AlertPopup 관련 데이터 추가
			showLoginAlert: false,
			loginAlertMessage: '',
		};
	},
	setup() {
		const router = useRouter();
		const currentPage = ref(1);
		const pageSize = ref(10);
		const total = ref(0);
		let eventList = ref([]);
		const bannerData = ref(null);
		const eventReqData = ref({
			page: currentPage.value,
			size: pageSize.value,
			brandUuid: sessionStorage.getItem("brandUuid"),
		});

		console.log("초기 eventReqData:", eventReqData.value);

		// Existing event data query
		const eventData = useQuery({
			queryKey: ["get-branch-event", eventReqData.value],
			queryFn: async () => {
				console.log("이벤트 API 호출:", eventReqData.value);
				const result = await getAxios("/hvm/v1/promotion/event", eventReqData.value);
				console.log("이벤트 API 응답:", result);
				return result;
			},
			enabled: true, // 자동 실행 활성화
		});

		// New banner data query
		const bannerQuery = useQuery({
			queryKey: ["get-event-main-banner"],
			queryFn: async () => {
				console.log("배너 API 호출");
				const result = await getAxios("/hvm/v1/promotion/event/main", {
					brandUuid: sessionStorage.getItem("brandUuid")
				});
				console.log("배너 API 응답:", result);
				return result;
			},
			enabled: true,
		});

		watch(
			() => eventData.data.value,
			(newData) => {
				console.log("이벤트 데이터 watch 트리거:", newData);

				if (newData && newData.page && newData.page.list) {
					// 기존 데이터에 추가하는 대신 새로 설정
					eventList.value = newData.page.list;
					total.value = newData.page.total;

					console.log("이벤트 리스트 업데이트:", {
						listLength: eventList.value.length,
						total: total.value,
						ingCount: eventList.value.filter(item => item.ingFlag === 'ING').length,
						endCount: eventList.value.filter(item => item.ingFlag === 'END').length,
						list: eventList.value
					});
				} else {
					console.warn("이벤트 데이터 구조가 예상과 다릅니다:", newData);
					eventList.value = [];
					total.value = 0;
				}
			},
			{ immediate: true }
		);

		watch(
			() => bannerQuery.data.value,
			(newData) => {
				console.log("배너 데이터 watch 트리거:", newData);
				if (newData) {
					bannerData.value = newData;
				}
			},
			{ immediate: true }
		);

		function routerLink(uuid, replyYn) {
			console.log("이벤트 클릭:", { uuid, replyYn });

			// replyYn이 'Y'인 경우 로그인 체크
			if (replyYn === 'Y') {
				// 로그인 상태 확인
				const storedUserInfo = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);

				if (!storedUserInfo) {
					// 로그인되지 않은 경우 로그인 필요 알림 표시
					console.log("HFO_PR_001: 댓글 참여 이벤트 - 로그인 필요");
					// Vue 2 방식으로 this를 통해 메서드 호출
					router.currentRoute.value.meta.showLoginRequiredAlert = true;
					return;
				}
			}

			// 로그인이 필요없거나 로그인된 경우 이벤트 정보 저장하고 이동
			sessionStorage.setItem("eventUuid", uuid);
			sessionStorage.setItem("replyYn", replyYn);
			router.push({ name: 'HFO_PR_003', params: { eventUuid: uuid } });
		}

		function routerToBanner(url) {
			if (url) {
				window.open(url, '_blank');
			}
		}

		return {
			eventList,
			eventData,
			eventReqData,
			currentPage,
			pageSize,
			total,
			routerLink,
			bannerData,
			bannerQuery,
			routerToBanner,
		};
	},
	mounted() {
		console.log("프로모션 페이지 마운트됨 - 진행중 탭 선택");
		console.log("마운트 시 상태:", {
			currentTab: this.currentTab,
			selectedTab: this.tab[this.currentTab].name,
			eventListLength: this.eventList.length,
			isLoading: this.eventData.isLoading.value,
			data: this.eventData.data.value
		});
	},
	methods: {
		changeTab(key) {
			console.log("탭 변경:", key, this.tab[key]);
			this.currentTab = key;
		},
		onPageChange(newPage) {
			this.eventList = [];
			this.currentPage = newPage;
			this.eventReqData.page = newPage;
			this.eventData.refetch(); // 새 페이지에 맞춰 데이터를 다시 요청
		},
		makeBrandImageUrl(imagePath) {
			return imagePath
				? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + imagePath
				: this.brandLogoSrc;
		},

		// SessionManager를 사용한 로그인 체크 메서드 수정
		routerLinkWithLoginCheck(uuid, replyYn) {
			console.log("이벤트 클릭:", { uuid, replyYn });

			// 댓글 입력시 로그인 필요해서 진입 가능하게 변경

			// replyYn이 'Y'인 경우 로그인 체크
			// if (replyYn === 'Y') {
			// 	// SessionManager.isSessionValid()로 로그인 상태 확인
			// 	if (!SessionManager.isSessionValid()) {
			// 		// 로그인되지 않은 경우 로그인 필요 알림 표시
			// 		console.log("HFO_PR_001: 댓글 참여 이벤트 - 로그인 필요");
			// 		this.showLoginRequiredAlert();
			// 		return;
			// 	}

			// 	console.log("HFO_PR_001: 로그인 상태 확인됨 - 이벤트 페이지로 이동");
			// }

			// 로그인이 필요없거나 로그인된 경우 이벤트 정보 저장하고 이동
			sessionStorage.setItem("eventUuid", uuid);
			sessionStorage.setItem("replyYn", replyYn);
			this.$router.push({ name: 'HFO_PR_003', params: { eventUuid: uuid } });
		},

		// 로그인 필요 AlertPopup 표시
		showLoginRequiredAlert() {
			console.log("HFO_PR_001: showLoginRequiredAlert 호출됨");

			this.loginAlertMessage = '로그인이 필요한 서비스입니다.\n로그인 페이지로 이동하시겠습니까?';
			this.showLoginAlert = true;

			console.log("HFO_PR_001: AlertPopup 설정 완료", {
				showLoginAlert: this.showLoginAlert,
				loginAlertMessage: this.loginAlertMessage
			});
		},

		// AlertPopup 확인 버튼 클릭 핸들러
		handleLoginAlertConfirm() {
			console.log("HFO_PR_001: AlertPopup 확인 버튼 클릭됨");
			this.showLoginAlert = false;
			this.$router.push('/HFO_LO_001');
		},

		// AlertPopup 취소 버튼 클릭 핸들러
		handleLoginAlertCancel() {
			console.log("HFO_PR_001: AlertPopup 취소 버튼 클릭됨");
			this.showLoginAlert = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.loading_area,
.no_data_area {
	text-align: center;
	padding: 40px 20px;

	p {
		color: #666;
	}
}

// AlertPopup 스타일 추가
.alert_popup {
	:deep(.alert-content) {
		text-align: center;
		padding: 20px;

		p {
			margin-bottom: 20px;
			line-height: 1.5;
			white-space: pre-line;
		}

		.alert-buttons {
			display: flex;
			gap: 10px;
			justify-content: center;

			.btn {
				padding: 8px 16px;
				border: none;
				border-radius: 4px;
				cursor: pointer;
				font-size: 14px;

				&.btn-primary {
					background: #007bff;
					color: white;

					&:hover {
						background: #0056b3;
					}
				}

				&.btn-secondary {
					background: #6c757d;
					color: white;

					&:hover {
						background: #545b62;
					}
				}
			}
		}
	}
}
</style>
